import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EscasoComponent } from './escaso/lista.component';
import { InventariadoComponent } from './inventariado/lista.component';
import { InventarioComponent } from './inventario/lista.component';
import { ResagadoComponent } from './resagado/lista.component';
import { PopularComponent } from './popular/lista.component';

import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  { path: 'reportes/inventario', redirectTo: '/reporte/inventario/inventario', pathMatch: 'full' },
  {
    path: 'reportes/inventario',
    children: [
      { path: 'escaso', component: EscasoComponent },
      { path: 'inventariado', component: InventariadoComponent },
      { path: 'inventario', component: InventarioComponent },
      { path: 'resago', component: ResagadoComponent },
      { path: 'popular', component: PopularComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class ReporteInventarioRoutingModule { }

